export default __webpack_public_path__ + "static/media/noah-rosenfield.4472e9e4.jpg";